import type { RenderListGroup as InsightListGroup } from '../../../insightRenderLists'
import { InsightPanels, InsightPanel } from '../InsightPanels'
import { InsightCardHeader } from './InsightCardHeader'
import { EntityListCard } from './EntityListCard'
import { Note } from '../InsightsBlocks'
import type { InsightListContent } from './insightListContent'
/** Two reusable list panels. Layout never adds overlapping row counts. */
export function ListGroupCard({ group, content }: { group: InsightListGroup; content?: InsightListContent[string] }) {
  return (
    <s-query-container>
      <s-section heading={group.title}>
        <s-icon slot="graphic" type={group.icon} />
        <InsightCardHeader title={group.title} help={group.help} />
        <s-stack gap="base">
          <InsightPanels collapseBelow={760}>
            {group.lists.map((list) => (
              <InsightPanel key={list.id}>
                <EntityListCard list={list} context={group.footer} rowContent={content?.[list.id]?.rows}>
                  {content?.[list.id]?.footer}
                </EntityListCard>
              </InsightPanel>
            ))}
          </InsightPanels>
          <s-divider />
          <Note>{group.footer}</Note>
        </s-stack>
      </s-section>
    </s-query-container>
  )
}
